import {Strings} from '@zvne/fe-framework/dist/presentation/language/strings';

const en = {
    status400: 'Wrongly formatted request.',
    status401: 'Authentication error.',
    status403: 'You are not authorized to make this request.',
    status404: 'Resource not found.',
    status5xx: 'Internal server error.',
    statusXxx: 'Unexpected response to a query.',
    noResponse: 'No response was received.',
    noRequest: 'Error while setting up the request.',
    statusCode: 'status code'
};

const hr = {
    status400: 'Pogrešno oblikovan zahtjev.',
    status401: 'Greška u dokazivanju identiteta.',
    status403: 'Nemate ovlasti izvršiti ovaj zahtjev.',
    status404: 'Resurs nije pronađen.',
    status5xx: 'Greška na poslužitelju.',
    statusXxx: 'Neočekivani odgovor na upit.',
    noResponse: 'Na postavljen upit nije primljen odgovor.',
    noRequest: 'Greška tijekom postavljanja upita.',
    statusCode: 'status kod'
};

export const strings: Strings<typeof en> = {en, hr};

